(() => {
  const init = () => {
    document.querySelectorAll('.contact-form__form').forEach((form) => {
      const topic = form.querySelector('[name="contact[topic]"]');
      const order = form.querySelector('[data-contact-field="order"]');
      const vehicle = form.querySelector('[data-contact-field="vehicle"]');
      const updateFields = () => {
        const value = topic.value;
        order.hidden = value !== 'Order & Shipping';
        vehicle.hidden = value !== 'Vehicle Fitment';
      };
      const requestedTopic = new URLSearchParams(window.location.search).get('topic');
      if (requestedTopic && [...topic.options].some((option) => option.value === requestedTopic)) {
        topic.value = requestedTopic;
        updateFields();
        if (window.location.hash === '#contact-form') topic.focus();
      } else updateFields();
      topic.addEventListener('change', updateFields);
      form.addEventListener('submit', () => {
        const submit = form.querySelector('[type="submit"]');
        if (submit && form.checkValidity()) { submit.disabled = true; submit.setAttribute('aria-disabled', 'true'); }
      });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
